import React from "react";

import { Result } from "antd";

import { SmileOutlined } from "@ant-design/icons";

import PropTypes from "prop-types";

export const WaitingForACompany = ({company_id = ""}) => {
	return company_id !== "" ? <></> :
		<Result
			icon={<SmileOutlined />}
			title="Por Favor Selecciona Una Empresa"
		/>;
};

WaitingForACompany.propTypes = {
	company_id: PropTypes.string.isRequired,
};
